import { Box, Button, Stack } from '@chakra-ui/react'
import { Link as RouterLink, isRouteErrorResponse, useRouteError } from 'react-router-dom'

import { ErrorState } from '@/components/feedback/ErrorState'
import { paths } from './paths'

/**
 * Route-scoped boundary. The shell stays mounted so navigation still works after
 * a page fails to render or its chunk fails to load.
 */
const RouteError = () => {
  const error = useRouteError()
  const isResponse = isRouteErrorResponse(error)

  const title = isResponse ? `${error.status} ${error.statusText}` : 'This page failed to load'
  const description = isResponse
    ? (error.data?.message ?? 'The page could not be displayed.')
    : (error?.message ?? 'An unexpected error interrupted this page.')

  return (
    <Box padding={{ base: '5', md: '8' }}>
      <Stack layerStyle="card" align="center" gap="0">
        <ErrorState
          title={title}
          description={description}
          onRetry={() => window.location.reload()}
          retryLabel="Reload page"
        />
        <Button asChild variant="ghost" size="sm" marginBottom="8">
          <RouterLink to={paths.usage}>Back to overview</RouterLink>
        </Button>
      </Stack>
    </Box>
  )
}

export default RouteError
